import { ID } from 'shared/types/id';
import { HabitSortingMode } from 'shared/types/sorting-mode';

import { getUser, getUserRef } from './get-user';
import { updateDocWithTimestamp } from './helpers';

export const updateHabitOrder = async (habitOrder: ID[]) => {
  const user = await getUser();

  // without a user we cannot update anything.
  if (!user) {
    return;
  }

  const userRef = await getUserRef();

  if (!userRef) {
    return;
  }

  updateDocWithTimestamp(userRef, {
    'settings.habitSorting': Array.from(new Set(habitOrder)),
    'settings.habitSortingMode': HabitSortingMode.Custom,
  });
};
